<template>
    <!-- SECTION: Template -->
    <div>
        <!-- ANCHOR: MainVisual -->
        <div class="main-visual d-flex justify-center align-center">
            <div class="main-visual__body" :class="{ 'loading': isVisualLoading }">
                <div class="hero-bg" aria-hidden="true"></div>

                <div class="main-visual__item">
                    <div class="hero-inner c-contanier">
                        <!-- ANCHOR: Hero Copy (피그마 카피) -->
                        <section class="hero-copy">
                            <div class="hero-copy__eyebrow">
                                {{ $t('home.section1.texts.text1') }}
                            </div>

                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <h1
                                class="le-heading1 hero-copy__title"
                                v-html="$t('home.section1.texts.text2')"
                            ></h1>

                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <p
                                class="le-text-body1 hero-copy__desc"
                                v-html="$t('home.section1.texts.text4')"
                            ></p>

                            <div class="hero-copy__cta">
                                <v-btn
                                    :to="{ name: 'ContactPage' }"
                                    color="orange1"
                                    depressed
                                    :large="$vuetify.breakpoint.smAndUp"
                                    :small="$vuetify.breakpoint.xsOnly"
                                    class="text-white1"
                                >
                                    {{ $t('home.section1.btns.btn1') }}
                                </v-btn>
                            </div>
                        </section>

                        <!-- ANCHOR: Hero Visual (아크 모션 — GSAP initHeroMotion 구동) -->
                        <section
                            class="hero-visual"
                            id="visual"
                            aria-label="AI 역량 데이터 시각화"
                        >
                            <!-- eslint-disable -->
<div class="orbit" id="orbit">
          <!-- 배경 장식 카드(피그마 lg·md). 아크와 함께 스케일·이동. xs는 시안에 없어 숨김
               ⚠️ SVG 안에 넣지 말 것 : ① svg:not(:root) 의 UA 기본 overflow:hidden 에 잘림(우측 85px)  ② 아크 모션에 의도치 않게 딸려감 -->
          <img class="bg-card bg-card--global" :src="require('@/assets/img/main-hero/card-global.svg')" alt="" aria-hidden="true">
          <img class="bg-card bg-card--ai" :src="require('@/assets/img/main-hero/card-ai.svg')" alt="" aria-hidden="true">

          <!-- ══ SVG : 아크 링 장식(정적) + 동적 연결선 ══ (v6 그대로. orbit-ring.svg 와 동일 링 구조) -->
          <svg class="orbit-svg" viewBox="-65 -65 553 553" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true">
<path d="M417.89 211.06C417.89 96.7405 325.38 4.23047 211.06 4.23047C96.74 4.23047 4.22998 96.7405 4.22998 211.06C4.22998 325.38 96.74 417.89 211.06 417.89C325.38 417.89 417.89 325.38 417.89 211.06Z" stroke="white" stroke-width="6" stroke-miterlimit="10"/>
<path d="M354.24 211.06C354.24 131.92 290.2 67.8804 211.06 67.8804C131.92 67.8804 67.8799 131.92 67.8799 211.06C67.8799 290.2 131.92 354.24 211.06 354.24C290.2 354.24 354.24 290.2 354.24 211.06Z" stroke="white" stroke-width="4" stroke-miterlimit="10"/>
<!-- 파란 링 3개(paint0/1/4) : 원본은 mix-blend-mode:multiply 였으나 웹에선 배경과 blend 불가(아래 ⚠️) → 배경색을 미리 곱한 색으로 대체 -->
<path d="M421.75 211.25C421.75 94.9023 327.598 0.75 211.25 0.75C94.9023 0.75 0.75 94.9023 0.75 211.25C0.75 327.598 94.9023 421.75 211.25 421.75C327.598 421.75 421.75 327.598 421.75 211.25Z" stroke="url(#paint0_linear_5951_56670)" stroke-width="1.5" stroke-miterlimit="10"/>
<path d="M358.65 211.061C358.65 129.481 292.64 63.4707 211.06 63.4707C129.48 63.4707 63.4697 129.481 63.4697 211.061C63.4697 292.641 129.48 358.651 211.06 358.651C292.64 358.651 358.65 292.641 358.65 211.061Z" stroke="url(#paint1_linear_5951_56670)" stroke-width="2" stroke-miterlimit="10"/>
  <!-- ★ 동적 연결선 6쌍 (원본 정적 방사선 대체) : 코어 뒤에 그려 안쪽은 코어가 가림. JS가 끝점만 갱신 -->
  <g id="lines">
    <line class="conn-glow" data-i="0"/><line class="conn" data-i="0"/>
    <line class="conn-glow" data-i="1"/><line class="conn" data-i="1"/>
    <line class="conn-glow" data-i="2"/><line class="conn" data-i="2"/>
    <line class="conn-glow" data-i="3"/><line class="conn" data-i="3"/>
    <line class="conn-glow" data-i="4"/><line class="conn" data-i="4"/>
    <line class="conn-glow" data-i="5"/><line class="conn" data-i="5"/>
    <line class="conn-pulse" data-i="0" pathLength="100"/>
    <line class="conn-pulse" data-i="1" pathLength="100"/>
    <line class="conn-pulse" data-i="2" pathLength="100"/>
    <line class="conn-pulse" data-i="3" pathLength="100"/>
    <line class="conn-pulse" data-i="4" pathLength="100"/>
    <line class="conn-pulse" data-i="5" pathLength="100"/>
  </g>
<path d="M211.18 326.98C276.206 326.98 328.92 274.266 328.92 209.24C328.92 144.214 276.206 91.5 211.18 91.5C146.154 91.5 93.4402 144.214 93.4402 209.24C93.4402 274.266 146.154 326.98 211.18 326.98Z" fill="white"/>
<g opacity="0.8">
<path d="M291.815 289.882C336.35 245.347 336.35 173.141 291.815 128.605C247.279 84.0698 175.073 84.0698 130.538 128.605C86.0025 173.141 86.0025 245.347 130.538 289.882C175.073 334.417 247.279 334.417 291.815 289.882Z" fill="url(#paint2_linear_5951_56670)"/>
<mask id="mask0_5951_56670" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="94" y="92" width="234" height="234">
<rect x="94.2703" y="92.9102" width="233" height="233" fill="url(#pattern0_5951_56670)"/>
</mask>
<g mask="url(#mask0_5951_56670)">
<g style="mix-blend-mode:multiply" opacity="0.8">
<path d="M291.815 289.882C336.35 245.347 336.35 173.141 291.815 128.605C247.279 84.0698 175.073 84.0698 130.538 128.605C86.0025 173.141 86.0025 245.347 130.538 289.882C175.073 334.417 247.279 334.417 291.815 289.882Z" fill="#0E71F3"/>
</g>
</g>
</g>
<path opacity="0.3" d="M210.75 336.75C280.338 336.75 336.75 280.338 336.75 210.75C336.75 141.162 280.338 84.75 210.75 84.75C141.162 84.75 84.75 141.162 84.75 210.75C84.75 280.338 141.162 336.75 210.75 336.75Z" fill="url(#paint3_linear_5951_56670)" style="mix-blend-mode:color-dodge"/>
<path d="M339.87 211.06C339.87 139.86 282.26 82.25 211.06 82.25C139.86 82.25 82.25 139.86 82.25 211.06C82.25 282.26 139.86 339.87 211.06 339.87C282.26 339.87 339.87 282.26 339.87 211.06Z" stroke="url(#paint4_linear_5951_56670)" stroke-width="1.3" stroke-miterlimit="10"/>
<path d="M322.348 164.905C329.988 160.565 332.603 150.748 328.19 142.978C323.776 135.208 314.004 132.428 306.364 136.768C298.724 141.109 296.108 150.926 300.522 158.695C304.936 166.465 314.708 169.245 322.348 164.905Z" fill="url(#paint5_radial_5951_56670)" style="mix-blend-mode:screen"/>
<!-- 코어 발광 6점 : JS가 매 프레임 각 배지(data-i) 방향의 코어 가장자리(연결선이 코어에서 나오는 지점)에 정렬 → 배지 흔들림·롤링 재배치와 동기 -->
<circle class="core-glow" data-i="0" r="15.5" fill="url(#coreGlow)"/>
<circle class="core-glow" data-i="1" r="15.5" fill="url(#coreGlow)"/>
<circle class="core-glow" data-i="2" r="15.5" fill="url(#coreGlow)"/>
<circle class="core-glow" data-i="3" r="15.5" fill="url(#coreGlow)"/>
<circle class="core-glow" data-i="4" r="15.5" fill="url(#coreGlow)"/>
<circle class="core-glow" data-i="5" r="15.5" fill="url(#coreGlow)"/>
<defs>
<!-- 히어로 배경 복제용(#svgBg). objectBoundingBox 의 (0,0)→(1,1) 대각선은 박스 비율과 무관하게 TR/BL 이 같은 색이 되어
     CSS `linear-gradient(to bottom right, ...)` 과 정확히 동일 → .hero-bg 와 색·기울기가 일치한다.
     ⚠️ .hero-bg 의 그라데이션 색과 반드시 동일하게 유지할 것 -->
<linearGradient id="heroGrad" x1="0" y1="0" x2="1" y2="1">
<stop stop-color="#ebf4ff"/>
<stop offset="1" stop-color="#cce1fc"/>
</linearGradient>
<!-- 코어 발광점 공용 그라디언트(objectBoundingBox → 원을 옮기면 발광도 함께 이동). 원본 paint6~11 흰색 방사 글로우와 동일 스톱 -->
<radialGradient id="coreGlow" cx="0.5" cy="0.5" r="0.5">
<stop stop-color="white"/>
<stop offset="0.3558" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.6683" stop-color="white" stop-opacity="0"/>
</radialGradient>
<pattern id="pattern0_5951_56670" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_5951_56670" transform="scale(0.00429185)"/>
</pattern>
<!-- 원본 multiply 색 × 히어로 배경(#D6E7FD 214,231,253) 을 미리 곱한 값(웹은 SVG 밖 배경과 blend 불가 → 굽기) -->
<linearGradient id="paint0_linear_5951_56670" x1="12.7478" y1="139.012" x2="409.752" y2="283.498" gradientUnits="userSpaceOnUse">
<stop stop-color="#B4D2FD"/>
<stop offset="1" stop-color="#AFCFFD"/>
</linearGradient>
<!-- 원본 multiply 색 × 히어로 배경(#D6E7FD 214,231,253) 을 미리 곱한 값(웹은 SVG 밖 배경과 blend 불가 → 굽기) -->
<linearGradient id="paint1_linear_5951_56670" x1="71.3797" y1="160.231" x2="350.74" y2="261.901" gradientUnits="userSpaceOnUse">
<stop stop-color="#9FC5FD"/>
<stop offset="1" stop-color="#89B8FD"/>
</linearGradient>
<linearGradient id="paint2_linear_5951_56670" x1="103.998" y1="170.226" x2="318.368" y2="248.246" gradientUnits="userSpaceOnUse">
<stop stop-color="#97CFFE"/>
<stop offset="0.34" stop-color="#8FC0FF"/>
<stop offset="0.62" stop-color="#69A2FF"/>
<stop offset="1" stop-color="#488AFF"/>
</linearGradient>
<linearGradient id="paint3_linear_5951_56670" x1="199.878" y1="91.9974" x2="222.652" y2="342.203" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.17" stop-color="#FBFDFE"/>
<stop offset="0.31" stop-color="#F2F6FC"/>
<stop offset="0.43" stop-color="#E1ECF8"/>
<stop offset="0.54" stop-color="#CADDF2"/>
<stop offset="0.65" stop-color="#ACCAEC"/>
<stop offset="0.75" stop-color="#87B3E3"/>
<stop offset="0.85" stop-color="#5C98D9"/>
<stop offset="0.94" stop-color="#2E7BCF"/>
</linearGradient>
<!-- 원본 multiply 색 × 히어로 배경(#D6E7FD 214,231,253) 을 미리 곱한 값(웹은 SVG 밖 배경과 blend 불가 → 굽기) -->
<linearGradient id="paint4_linear_5951_56670" x1="81.59" y1="211.06" x2="340.52" y2="211.06" gradientUnits="userSpaceOnUse">
<stop stop-color="#B4D2FD"/>
<stop offset="1" stop-color="#AFCFFD"/>
</linearGradient>
<radialGradient id="paint5_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(557.723 28.4564) rotate(60.4) scale(16.3025 16.3025)">
<stop stop-color="white"/>
<stop offset="0.26" stop-color="white" stop-opacity="0.44"/>
<stop offset="0.36" stop-color="white" stop-opacity="0.31"/>
<stop offset="0.46" stop-color="white" stop-opacity="0.19"/>
<stop offset="0.56" stop-color="white" stop-opacity="0.11"/>
<stop offset="0.68" stop-color="white" stop-opacity="0.05"/>
<stop offset="0.81" stop-color="white" stop-opacity="0.01"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint6_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(312.03 152.41) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint7_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(111.03 152.41) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint8_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(111.03 267.41) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint9_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(311.03 267.41) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint10_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(211.03 92.4102) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint11_radial_5951_56670" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(211.03 324.41) rotate(90) scale(15.5)">
<stop stop-color="white"/>
<stop offset="0.355769" stop-color="white" stop-opacity="0.2"/>
<stop offset="0.668269" stop-color="white" stop-opacity="0"/>
</radialGradient>
<image id="image0_5951_56670" width="233" height="233" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>
</svg>

          <div class="ripple" id="ripple"></div>

          <div class="core"><div class="core-visual" id="coreVisual"><img class="core-img" :src="require('@/assets/img/main-hero/core-certificate.png')" alt="디지털 자격 증명서"><span class="core-sheen" id="coreSheen"></span></div></div>

          <!-- 배지 6개. data-i = DOM순서(= 각도 배열 순서). 60° 등간격 정육각 -->
          <div class="node" data-i="0"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-learning.png')" alt="학습"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.learning.title') }}<small>{{ $t('home.section1.badges.learning.sub') }}</small></span></div>
          <div class="node" data-i="1"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-ai.png')" alt="AI 분석"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.ai.title') }}<small>{{ $t('home.section1.badges.ai.sub') }}</small></span></div>
          <div class="node" data-i="2"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-global.png')" alt="글로벌 검증"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.global.title') }}<small>{{ $t('home.section1.badges.global.sub') }}</small></span></div>
          <div class="node" data-i="3"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-data.png')" alt="데이터 인사이트"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.data.title') }}<small>{{ $t('home.section1.badges.data.sub') }}</small></span></div>
          <div class="node" data-i="4"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-achievement.png')" alt="성과"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.achievement.title') }}<small>{{ $t('home.section1.badges.achievement.sub') }}</small></span></div>
          <div class="node" data-i="5"><div class="orb"><img class="badge-img" :src="require('@/assets/img/main-hero/icon-experience.png')" alt="경험"><span class="badge-glow"></span></div><span class="lbl">{{ $t('home.section1.badges.experience.title') }}<small>{{ $t('home.section1.badges.experience.sub') }}</small></span></div>

          <div class="hand-rig" id="hand"><span class="core-mint" id="mint"></span><img class="hand-img" :src="require('@/assets/img/main-hero/robot-hand.png')" alt="증명서를 누르는 로봇 손"></div>
        </div>
                            <!-- eslint-enable -->
                        </section>
                    </div>
                </div>
            </div>

            <div class="main-visual__arrow">
                <v-img
                    :src="require('@/assets/svg/others/ic_chevrons_down_outline.svg')"
                    alt=""
                    :width="$vuetify.breakpoint.mdAndUp ? 48 : ($vuetify.breakpoint.smOnly ? 32 : 32)"
                />
            </div>

            <div class="quick-menu-wrap c-contanier d-flex justify-center align-center position-relative h-100">
                <!-- 퀵메뉴 -->
                <div
                    v-if="!$vuetify.breakpoint.smAndDown"
                    class="d-flex flex-column quick-menu gap-3"
                >
                    <div class="position-relative">
                        <div
                            class="position-absolute"
                            style="z-index: 1; left: -17px; top: -20px;"
                        >
                            <img :src="require(`@/assets/img/main-q-new.png`)" />
                        </div>
                        
                        <v-btn
                            href="https://lecos.co.kr/kor/company/event-detail?id=15"
                            color="yellow2"
                            depressed
                            class="elevation-3"
                        >
                            <div class="d-flex flex-column text-center">
                                <img :src="require(`@/assets/img/main-q-mwallet.png`)">
                                <div class="quick-menu__text pb-2 le-text-subtitle4 text-gray1">
                                    {{ $t('home.section1.qbtns.btn0') }}
                                </div>
                            </div>
                        </v-btn>
                    </div>
                    
                    <v-btn
                        :to="{ name: 'SampleBadgesV3Page' }"
                        color="yellow2"
                        depressed
                        class="elevation-3"
                    >
                        <div class="d-flex flex-column text-center">
                            <img :src="require(`@/assets/img/main-q-issue.png`)">
                            <div class="quick-menu__text pb-2 le-text-subtitle4 text-gray1">
                                {{ $t('home.section1.qbtns.btn1') }}
                            </div>
                        </div>
                    </v-btn>

                    <v-btn
                        href="https://wallet-kr.openbadge.net/"
                        target="_blank"
                        color="yellow2"
                        depressed
                        class="elevation-3"
                    >
                        <div class="d-flex flex-column text-center">
                            <img :src="require(`@/assets/img/main-q-wlogin3.png`)">
                            <div class="quick-menu__text pb-2 le-text-subtitle4 text-gray1">
                                {{ $t('home.section1.qbtns.btn2') }}
                            </div>
                        </div>
                    </v-btn>

                    <!-- <v-btn
                        href="https://play.google.com/store/apps/details?id=net.openbadge.obwalletapp"
                        target="_blank"
                        color="white"
                        depressed
                        class="elevation-3"
                    >
                        <div class="d-flex flex-column text-center">
                            <img :src="require(`@/assets/img/main-q-3.png`)">
                            <div class="quick-menu__text pb-2 le-text-subtitle4 text-gray1">
                                {{ $t('home.section1.qbtns.btn3') }}
                            </div>
                        </div>
                    </v-btn> -->

                    <v-btn
                        href="https://www.openbadge-global.com/ns/portal/openbadge/login"
                        target="_blank"
                        color="blue14"
                        depressed
                        class="elevation-3"
                    >
                        <div class="d-flex flex-column text-center">
                            <img :src="require(`@/assets/img/main-q-4.png`)">
                            <div class="quick-menu__text pb-2 le-text-subtitle4 text-gray1">
                                {{ $t('home.section1.qbtns.btn4') }}
                            </div>
                        </div>
                    </v-btn>
                </div>
            </div>
        </div>

        <!-- ANCHOR: 최다 고객사 -->
        <section class="c-section bg-blue9 d-flex justify-center">
            <div class="c-contanier">
                <h2
                    class="text-center le-heading3 c-title"
                    v-html="$t('home.section2.texts.text1')"
                >
                </h2>

                <div class="d-flex client-stats">
                    <!-- 도입 고객사 -->
                    <div class="client-stats__column text-center">
                        <div
                            class="circle-obj"
                            :class="{'mb-10': !$vuetify.breakpoint.xsOnly, 'mb-5': $vuetify.breakpoint.xsOnly}"
                        >
                            <v-avatar
                                class="rounded-0"
                                :size="($vuetify.breakpoint.mdAndUp ? 100 : $vuetify.breakpoint.smOnly ? 76 : $vuetify.breakpoint.xsOnly ? 73 : 100)"
                            >
                                <v-img
                                    :src="require('@/assets/img/home-largest-company.png')"
                                    alt=""
                                />
                            </v-avatar>
                        </div>

                        <div class="le-heading4 text-blue3 mb-5">
                            {{ $t('home.section2.texts.text2') }}
                        </div>

                        <div class="le-heading6 mb-3">
                            {{ $t('home.section2.texts.text3') }}
                        </div>
                    </div>

                    <!-- 등록된 배지 -->
                    <div class="client-stats__column text-center">
                        <div
                            class="circle-obj"
                            :class="{'mb-10': !$vuetify.breakpoint.xsOnly, 'mb-5': $vuetify.breakpoint.xsOnly}"
                        >
                            <v-avatar
                                class="rounded-0"
                                :size="($vuetify.breakpoint.mdAndUp ? 100 : $vuetify.breakpoint.smOnly ? 76 : $vuetify.breakpoint.xsOnly ? 73 : 100)"
                            >
                                <v-img
                                    :src="require('@/assets/img/home-largest-certificate.png')"
                                    alt=""
                                />
                            </v-avatar>
                        </div>

                        <div class="le-heading4 text-blue3 mb-5">
                            {{ $t('home.section2.texts.text4') }}
                        </div>

                        <div class="le-heading6 mb-3">
                            {{ $t('home.section2.texts.text5') }}
                        </div>
                    </div>

                    <!-- 발행된 배지 -->
                    <div class="client-stats__column text-center">
                        <div
                            class="circle-obj "
                            :class="{'mb-10': !$vuetify.breakpoint.xsOnly, 'mb-5': $vuetify.breakpoint.xsOnly}"
                        >
                            <v-avatar
                                class="rounded-0"
                                :size="($vuetify.breakpoint.mdAndUp ? 100 : $vuetify.breakpoint.smOnly ? 76 : $vuetify.breakpoint.xsOnly ? 73 : 100)"
                            >
                                <v-img
                                    :src="require('@/assets/img/home-largest-badge.png')"
                                    alt=""
                                />
                            </v-avatar>
                        </div>

                        <div class="le-heading4 text-blue3 mb-5">
                            {{ $t('home.section2.texts.text6') }}
                        </div>

                        <div class="le-heading6 mb-3">
                            {{ $t('home.section2.texts.text7') }}
                        </div>
                    </div>

                    <!-- 지갑 사용자 -->
                    <div class="client-stats__column text-center">
                        <div
                            class="circle-obj"
                            :class="{'mb-10': !$vuetify.breakpoint.xsOnly, 'mb-5': $vuetify.breakpoint.xsOnly}"
                        >
                            <v-avatar
                                class="rounded-0"
                                :size="($vuetify.breakpoint.mdAndUp ? 100 : $vuetify.breakpoint.smOnly ? 76 : $vuetify.breakpoint.xsOnly ? 73 : 100)"
                            >
                                <v-img
                                    :src="require('@/assets/img/home-largest-wallet.png')"
                                    alt=""
                                />
                            </v-avatar>
                        </div>

                        <div class="le-heading4 text-blue3 mb-5">
                            {{ $t('home.section2.texts.text8') }}
                        </div>

                        <div class="le-heading6 mb-3">
                            {{ $t('home.section2.texts.text9') }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 롤링 배너 -->
        <div 
            class="rbn bg-blue8" 
            :class="{
                'py-16': $vuetify.breakpoint.mdAndUp,
                'py-15': $vuetify.breakpoint.smOnly,
                'py-10': $vuetify.breakpoint.xsOnly,
            }"
        >
            <swiper :options="rbnSwiperOptions">
                <swiper-slide
                    v-for="(image, index) in rbnImages"
                    :key="index"
                >
                    <img
                        :src="image"
                        alt="Banner Image"
                    />
                </swiper-slide>
            </swiper>
        </div>

        <!-- ANCHOR: 높은 고객 만족도 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <h2 class="text-center le-heading3 c-title">
                    {{ $t('home.section3.texts.text1') }}
                </h2>

                <div class="d-flex">
                    <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="10"
                        >
                            <v-row class="d-flex justify-center">
                                <!-- 후기 1 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between h-100"
                                        color="blue7"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div>
                                            <div class="mb-5 w-100">
                                                <v-img
                                                    :src="require('@/assets/img/home-quotation-blue.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    alt=""
                                                />
                                            </div>

                                            <p
                                                class="le-text-body1 mb-5"
                                                v-html="$t('home.section3.texts.text2')"
                                            >
                                            </p>
                                        </div>

                                        <div class="d-flex flex-column justify-center align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-high-1.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                                    alt=""
                                                />
                                            </div>

                                            <p class="le-text-subtitle3">
                                                {{ $t('home.section3.texts.text3') }}
                                            </p>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 후기 2 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between h-100"
                                        color="orange2"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div>
                                            <div class="mb-5 w-100">
                                                <v-img
                                                    :src="require('@/assets/img/home-quotation-orange.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    alt=""
                                                />
                                            </div>

                                            <p
                                                class="le-text-body1 mb-5"
                                                v-html="$t('home.section3.texts.text4')"
                                            >
                                            </p>
                                        </div>

                                        <div class="d-flex flex-column justify-center align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-high-2.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smOnly ? 76 : 76)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smOnly ? 76 : 76)"
                                                    alt=""
                                                />
                                            </div>

                                            <p class="le-text-subtitle3">
                                                {{ $t('home.section3.texts.text5') }}
                                            </p>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 후기 3 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between h-100"
                                        color="green1"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div>
                                            <div class="mb-5 w-100">
                                                <v-img
                                                    :src="require('@/assets/img/home-quotation-green.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 60 : ($vuetify.breakpoint.smOnly ? 60 : 48)"
                                                    alt=""
                                                />
                                            </div>

                                            <p
                                                class="le-text-body1 mb-5"
                                                v-html="$t('home.section3.texts.text6')"
                                            >
                                            </p>
                                        </div>

                                        <div class="d-flex flex-column justify-center align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-high-3.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 138 : ($vuetify.breakpoint.smAndDown ? 76 : 76)"
                                                    alt=""
                                                />
                                            </div>

                                            <p class="le-text-subtitle3">
                                                {{ $t('home.section3.texts.text7') }}
                                            </p>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 완벽한 오픈배지 -->
        <section class="c-section bg-blue9 d-flex justify-center">
            <div class="c-contanier">
                <div class="c-title text-center">
                    <h2 class="text-center le-heading3 mb-5">
                        {{ $t('home.section4.texts.text1') }}
                    </h2>

                    <p class="le-text-subtitle1">
                        {{ $t('home.section4.texts.text2') }}
                    </p>
                </div>

                <div class="d-flex">
                    <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="10"
                        >
                            <v-row class="d-flex justify-center">
                                <!-- 발행 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card 
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section4.texts.text3') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section4.texts.text4') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section4.texts.text5') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-perfect-1.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    :to="{ name: 'IssuancePage' }"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 수령 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card 
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section4.texts.text6') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section4.texts.text7') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section4.texts.text8') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-perfect-2.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    :to="{ name: 'ManagementPage' }"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 검증 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card 
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section4.texts.text9') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section4.texts.text10') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-perfect-3.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    href="https://www.lecos.co.kr/openbadge/verify.html"
                                                    target="_blank"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 프리미엄 오픈배지 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <div class="c-title text-center">
                    <h2 class="text-center le-heading3 mb-5">
                        {{ $t('home.section5.texts.text1') }}
                    </h2>

                    <p class="le-text-subtitle1">
                        {{ $t('home.section5.texts.text2') }}
                    </p>
                </div>

                <div class="d-flex">
                    <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="10"
                        >
                            <v-row class="d-flex justify-center">
                                <!-- 교육 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        color="gray7"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section5.texts.text3') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text4') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text5') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text6') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-premium-1.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    :to="{ name: 'EducationPage' }"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 기업 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        color="orange2"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section5.texts.text7') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text8') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text9') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text10') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-premium-2.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    :to="{ name: 'EnterprisePage' }"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>

                                <!-- 기관 -->
                                <v-col
                                    cols="12"
                                    md="4"
                                    sm="4"
                                    :style="$vuetify.breakpoint.xsOnly ? 'max-width: 370px;' : ''"
                                    class="d-flex justify-center"
                                >
                                    <v-card
                                        class="d-flex flex-column align-center justify-space-between w-100 h-100"
                                        color="blue6"
                                        :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 282px;' : ''"
                                    >
                                        <div class="d-flex flex-column align-center">
                                            <p class="le-heading4 mb-3">
                                                {{ $t('home.section5.texts.text11') }}
                                            </p>

                                            <div class="d-flex flex-wrap justify-center gap-2 mb-5">
                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text12') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text13') }}
                                                </v-chip>

                                                <v-chip
                                                    outlined
                                                    small
                                                >
                                                    {{ $t('home.section5.texts.text14') }}
                                                </v-chip>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-column align-center">
                                            <div
                                                :class="{
                                                    'mb-10': $vuetify.breakpoint.mdAndUp,
                                                    'mb-5': $vuetify.breakpoint.smAndDown
                                                }"
                                            >
                                                <v-img
                                                    :src="require('@/assets/img/home-premium-3.png')"
                                                    :width="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    :height="$vuetify.breakpoint.mdAndUp ? 112 : ($vuetify.breakpoint.smAndDown ? 72 : 112)"
                                                    alt=""
                                                />
                                            </div>

                                            <div>
                                                <v-btn
                                                    :to="{ name: 'AssociationPage' }"
                                                    color="orange1"
                                                    :small="$vuetify.breakpoint.xsOnly"
                                                    depressed
                                                    class="text-white1"
                                                >
                                                    {{ $t('home.section4.btns.btn1') }}
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <!-- ANCHOR: 메인 공통 공지 모달 -->
        <!-- 시스템 팝업 -->
        <!-- <LoginPathModal
            :key="`login-path-${currentLangCode}`"
            v-model="loginPathDialog"
            :use-shared-overlay="true"
            :position="systemPopupPosition"
            @visible-change="onSystemPopupVisibleChange"
        /> -->

        <!-- Admin에서 등록한 메인 팝업들 -->
        <UserMainPopup
            v-for="(popup, idx) in filteredMainPopupList"
            :key="`${popup.id}_${currentLangCode}`"
            :popup="popup"
            :use-shared-overlay="true"
            :position="getAdminPopupPosition(idx)"
            @visible-change="onAdminPopupVisibleChange"
        />

        <!-- ✅ 공통 dim (팝업이 하나라도 열려 있으면 1개만 표시) -->
        <div
            v-if="anyPopupVisible"
            class="global-overlay"
        ></div>

        <div
            v-if="false"
            style="z-index:9999; position: absolute; left: 0; top: 0; background-color: red;"
        >
            {{ systemPopupPosition }}
        </div>
        <!-- <Alhe8thForumModal :dialog="false" /> -->
        <!-- <NewYearModal2025 :dialog="false" /> -->
        <!-- <SeoulMiniSeminaModal :dialog="false" /> -->

        <!-- 두 개의 모달 -->
        <!-- <SeoulRiseForum2025Modal v-model="seoulRiseForum2025Dialog" /> -->
        <!-- <LoginPathModal v-model="loginPathDialog" /> -->

        <!-- ✅ 커스텀 dim: 둘 중 하나라도 열리면 표시 -->
        <!-- <div
            v-if="seoulRiseForum2025Dialog || loginPathDialog"
            class="global-overlay"
        ></div> -->
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { getHomeMetaInfo } from '@/utils/metaInfo.js';
// https://github.surmon.me/vue-awesome-swiper
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { isMobile, isTablet } from 'mobile-device-detect';
// import NewYearModal2025 from '@/components/modal/NewYearModal2025';
// import SeoulMiniSeminaModal from '@/components/modal/SeoulMiniSeminaModal';
// import SeoulMiniSeminaModal from '@/components/modal/SeoulMiniSeminaModal';
// import Alhe8thForumModal from '@/components/modal/Alhe8thForumModal';
// import SeoulRiseForum2025Modal from '@/components/modal/SeoulRiseForum2025Modal';
// import LoginPathModal from '@/components/modal/LoginPathModal';
import UserMainPopup from '@/components/modal/UserMainPopup.vue';
import { gsap } from 'gsap';

/* eslint-disable */
/* ══════════════════════════════════════════════════════════════════════════════
   Hero 아크 비주얼 모션 (docs/main-visual-renewal 프로토타입 v7 이식)
   - 튜닝은 전부 아래 CFG 한 곳. 반응형: Vuetify xs(<600)=xsOnly / sm(600-959)=mdOnly / md↑(≥960)=lgAndUp
   - initHeroMotion(root) : mounted 에서 호출, beforeDestroy 에서 destroy()
   - 프로토타입(2-space) 원문 유지 → 이 블록만 eslint-disable (하단 export default 부터 재적용)
   ════════════════════════════════════════════════════════════════════════════ */
const CFG = {
  // ═══ 비율 (orbit 박스 = SVG 아크 좌표계) ═══
  ringR:  440/1200,   // 배지 궤도 반지름(orbit 박스 대비) = SVG 외곽 링 위
  badgeW: 16,         // 배지 지름 % (lg 렌더 ≈89.4 = 피그마 Visual-Icon. 15→16, md 도 비례↑)
  coreW:  42,         // 코어(증명서) 지름 % — 최종 Click.png 디스크가 SVG 코어원을 덮도록
  gapPx:  12,         // 배지 사이 최소 여백 px
  angles: [0,60,120,180,240,300],   // xs 전용(등간격 정육각). wide 는 i*60 롤링 분배로 자동
  labelPx: 16,        // 라벨 타이틀 화면상 고정 크기(px) — 피그마는 모든 분기 16/14 고정(orbit 스케일 상쇄)

  // ═══ 유휴 모션 (아크판·링은 고정, 배지만 미세하게) ═══
  wobble: 0.8,        // 배지 각도 미세 흔들림(°) → 연결선이 쫀득하게 재연결
  bobY:  [-2.4,-1.4], // 배지 상하 유영 진폭(px)
  bobDur:[5.4, 7.2],  // 배지 상하 유영 주기(초)

  // ═══ 반응형 분기 ═══
  xsBreak: 600,       // 이 폭 미만 = xs(세로 스택). CSS @media(599.98) 와 일치

  // ═══ wide(≥600, 2단) : v6 롤링 = 아크는 크게 유지, 좁아지면 배지가 좌측 호로 몰리고 코어·우측BG는 화면 밖으로 ═══
  //   lg(넓은 밴드)  → 풀 원 중앙(배지 60° 등간격)
  //   md(좁은 밴드)  → 좌측 클러스터 + 우측 아크 오프스크린 (피그마 mdOnly 방향)
  //   gapCopy/gapEdge = 카피 오른쪽 / 화면(퀵메뉴) 왼쪽 과의 간격 / labelGap = 라벨이 배지 밖으로 뻗는 여백
  //   leftReserve = md(좁은밴드) 클러스터 시 좌측 배지가 카피에서 떨어지는 여백. 코어 좌우 위치 = bandL + Rs + leftReserve (값↓ = 코어 왼쪽으로 → 더 보임)
  //   smMaxR = sm(<960)에서 아크 최대 반지름 상한(px). 넓은 sm에서 아크가 과도하게 커지지 않게 → 대신 우측으로 밀려 화면 밖으로 (RsBox=220 대비 작게)
  wide: { gapCopy:28, gapEdge:20, labelGap:12, leftReserve:44, lgR:204.5, mdR:163, coreVis:150, coreLg:39.1, startShiftX:35 },   // startShiftX: lg(퀵메뉴 O)에서 아크 전체(코어·배지·bg카드·로봇손 통째)를 기본 +Npx 우측 이동. 50→35(사용자: 전체 15px 좌측)   // lgR/mdR = 아크(배지궤도) 반지름(px) → 피그마 lgAndUp 배지궤도 208 / mdOnly 163. lg 는 코어=coreLg%(coreW 대신)로 코어 지름 218 유지(coreLg/ringR×lgR≈218). coreLg 없는 md 는 coreW(42%)로 코어=1.1455×mdR≈187. 링·배지·로봇손도 sc로 함께 스케일(비율 유지). coreVis: 코어 중심이 화면(md는 퀵메뉴) 우측에서 최소 이만큼(px) 떨어져 보이게(값↑=코어 더 왼쪽/우측잘림↓)

  // ═══ xs(세로 스택) : 카피 아래 풀서클. 피그마 xsOnly 비율 = BG(외곽링)≈bgFrac×화면폭 ═══
  //   bgFrac = 외곽링 지름/화면폭(피그마 224/360≈0.62). labelV/H = 16/14 라벨 상하·좌우 여백
  //   badgeW/coreW = xs 전용 아이콘·코어 지름 %(피그마 xs는 아크 대비 더 큼 : icon/BG≈0.23, core/BG≈0.66)
  //   labelV = 서브 없는 1줄 라벨 세로여백. capK = 세로 상한(1=가용높이 최대한 사용)
  //   ★ 피그마 xsOnly(360) 실측 기준값 (Main-Hero(xsOnly) 360×648, 히어로 567) :
  //     BG 외곽링 224 / 아이콘 51.4×53.2 / 코어프레임 147.4(내부 파란디스크≈115) / 로봇손 129×156 / 라벨 12px
  //     → bgFrac=224/360, 링렌더율 0.3806(외곽 스트로크 반지름/viewBox), 배지궤도 ringR=0.39(링 바로 바깥=시안대로)
  xs:   { bgFrac:224/360, ringR:0.39, capK:0.86, marginTop:4, marginBot:4, labelV:15, labelH:28, minW:200, badgeW:17.5, coreW:47.25, labelPx:12 },
};

// xs 전용 라벨 방향(피그마 xsOnly 실측) : 방사형(대각) 대신 배지별 고정 방향.
//   0 학습=위 / 1 AI분석=오른쪽(배지높이) / 2 글로벌=아래+살짝우 / 3 데이터=아래 / 4 성과=아래+살짝좌 / 5 경험=왼쪽(배지높이)
const XS_LABEL_DIR = [ [0,-1], [1,0], [0.45,0.89], [0,1], [-0.3,0.95], [-1,0] ];
// wide 풀서클(fullFits=lgAndUp) 라벨 방향(피그마 lgAndUp 실측) : 상단3(학습·AI·경험)=위쪽, 하단3(글로벌·데이터·성과)=아래쪽.
//   상단 측면(AI·경험)은 방사형보다 '위'로. 롤링(mdOnly, 배지 클러스터)에서는 이 배열 안 쓰고 방사형(sx,cyv) 유지.
const WIDE_LABEL_DIR = [ [0,-1], [0.44,-0.90], [0.74,0.67], [0,1], [-0.79,0.60], [-0.22,-0.97] ];

function initHeroMotion(root){
  const $=s=>root.querySelector(s), $$=s=>Array.from(root.querySelectorAll(s));
  const PI=Math.PI, D2R=PI/180;
  const visual=$('#visual'), orbit=$('#orbit'), heroEl=$('.main-visual'), copyEl=$('.hero-copy'),
        coreEl=$('.core'), coreVisual=$('#coreVisual'), sheen=$('#coreSheen'), mint=$('#mint'), ripple=$('#ripple'), hand=$('#hand');
  // ⚠️ .quick-menu 는 v-if(!smAndDown)로 960 경계에서 DOM 제거/재생성됨 → 캐싱 금지, 매 렌더 새로 조회(회전 시 옛 노드 참조 방지)
  const nodes=$$('.node'), lbls=nodes.map(n=>n.querySelector('.lbl'));
  const linesMain=$$('.conn'), linesGlow=$$('.conn-glow'), linesPulse=$$('.conn-pulse');
  const glows=$$('.core-glow').sort((a,b)=>a.dataset.i-b.dataset.i);   // 코어 발광 6점(data-i 순) → 매 프레임 배지 방향으로 정렬
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --badge-w/--core-w 는 render()가 분기별로 매 프레임 설정
  // 연결선 시작점(코어 중심) 고정 : 원본 SVG(423계) 중심 (211.06,211.06)
  [...linesMain,...linesGlow,...linesPulse].forEach(l=>{ l.setAttribute('x1',211.06); l.setAttribute('y1',211.06); });

  let regime='wide', phase=0, tips=null;
  const setRegime = ()=>{ regime = window.innerWidth >= CFG.xsBreak ? 'wide' : 'narrow'; };

  /* ── 매 프레임 : 아크 크기·위치 계산 → 배지 6개 각도 산출 → 라벨·쫀득 선 ──
       wide = v6 롤링(넓으면 풀원 / 좁으면 좌측 클러스터+우측 오프스크린)  |  narrow(xs) = 풀서클 스택 */
  function render(instant){
    const w = orbit.clientWidth;                       // 기준 박스(wide 600 / xs 100vw)
    const hb = heroEl.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    const vr = visual.getBoundingClientRect();
    const quickMenu = $('.quick-menu');                          // 매 렌더 새로 조회(v-if 재생성 대응)
    const qmOn = quickMenu && quickMenu.offsetParent !== null;   // 퀵메뉴 노출(=lg,≥960). 코어 지름 보정에 사용
    // 배지·코어 지름 % : xs는 피그마 비율(아이콘·코어가 아크 대비 더 큼), lg는 coreLg(궤도 208로 키운 만큼 코어 218 유지)
    const badgeWcur = (regime==='narrow') ? CFG.xs.badgeW : CFG.badgeW;
    const coreWcur  = (regime==='narrow') ? CFG.xs.coreW  : (qmOn ? CFG.wide.coreLg : CFG.coreW);
    const ringRcur  = (regime==='narrow') ? CFG.xs.ringR  : CFG.ringR;    // xs: 배지를 외곽링 바로 바깥(피그마 시안)으로 → 링 장식보다 살짝 큰 궤도
    const labelPxCur= (regime==='narrow') ? CFG.xs.labelPx : CFG.labelPx; // xs: 라벨 12px (피그마 xsOnly), wide: 16px
    visual.style.setProperty('--badge-w', badgeWcur+'%');
    visual.style.setProperty('--core-w',  coreWcur +'%');
    const Rpx = ringRcur*w, Rsvg = ringRcur*553, badgeR0 = (badgeWcur/100)*w*0.5;   // Rsvg: 원본 SVG viewBox(553=423÷0.765 패딩) 좌표계에서 배지까지 반경
    const Rglow = coreWcur*(553/200)*1.0645;   // 코어 발광점 반지름(SVG좌표) = 코어 rim ×1.0645(=lg 기준 rim 바깥 +7px). 피그마 시안 실측 1.05~1.08 범위 안. 비례계수라 모든 구간 균일. coreW 따라 스케일
    const ang = new Array(6);
    let sc=1, tx=0, ty=0, wideCtx=null;

    if(regime==='wide'){
      // ── 아크 크기·위치 (v6) : 반지름을 밴드/세로에 맞춰 역산, 좁으면 코어를 우측으로(우측 아크 오프스크린) ──
      const labelPad = Math.max(0, ...lbls.map(l=>l.offsetWidth||0));
      const qmLeft= qmOn ? quickMenu.getBoundingClientRect().left : vw;   // qmOn 은 상단에서 계산
      const kBadge= CFG.badgeW/(2*CFG.ringR*100);         // 배지반지름 / 궤도반지름
      const RsBox = CFG.ringR*w;                          // 기본 반지름(박스). 이 이상 안 키움 → 라벨 16/14 유지
      const RsVmax= (hb.height/2 - 52)/(1 + kBadge);      // 세로(히어로 높이)로 담기는 최대 반지름
      const bandL = copyEl.getBoundingClientRect().right + CFG.wide.gapCopy;
      const bandR = qmLeft - CFG.wide.gapEdge, band = bandR - bandL;
      const labelExt = labelPad + CFG.wide.labelGap;      // 좌측 라벨이 배지 밖으로 뻗는 길이
      // ★ 아크 크기 = 디자이너 아트보드별 상한(코어 Click 목표). 롤링 판정(fullFits)은 기존 임계(RsFit)로 계산 → 아크 축소해도 롤링/센터 분기 안 흔들림
      const RsFit = Math.max(70, Math.min(RsBox, RsVmax));       // 롤링/센터 판정용(기존 220 기준)
      const fullFits = qmOn && band >= 2*(RsFit + labelExt);    // 풀 원(중앙배치)는 퀵메뉴 있는 lg(≥960) 전용. md(퀵메뉴X)는 항상 롤링(우측 부착) → md 내 센터↔롤링 점프 제거
      const capR = qmOn ? CFG.wide.lgR : CFG.wide.mdR;          // ≥960(퀵메뉴·lgAndUp)→190(코어218) / 600-959(mdOnly)→163(코어187). 세로 부족하면 RsVmax로 더 축소
      let Rs = Math.max(70, Math.min(capR, RsVmax));
      let coreX = fullFits ? (bandL + band/2) : (bandL + Rs + CFG.wide.leftReserve);  // 부족(롤링) → 좌측 배지=카피옆, 코어는 그 우측(우측 아크 BG는 화면 밖). leftReserve 로 코어 가시성 조절
      if(!fullFits) coreX = Math.min(coreX, (qmOn ? qmLeft : vw) - CFG.wide.coreVis);   // 롤링: 코어(증명서)가 화면(md는 퀵메뉴) 우측 밖으로 너무 안 나가게 좌측 클램프 → 우측 잘림↓ + 가시호↑ → 배지 균형(아래 치우침 방지)
      sc = Rs/RsBox;
      tx = coreX - (vr.left + w/2);
      ty = 0;                                             // 세로는 그리드가 이미 중앙정렬(visual 정사각) → 0
      gsap.set(orbit,{ x:tx, y:ty, scale:sc });

      // 코어 화면좌표 + "보이는 각도구간 [a0,a1]"
      const cr = coreEl.getBoundingClientRect(), Cx = cr.left+cr.width/2;
      const RsScreen = RsBox*sc, badgeRs = badgeR0*sc;
      const wRightPad = fullFits ? labelExt : (kBadge*Rs + labelPad*0.6 + 16);   // 롤링: 우측 배지의 라벨이 화면 밖으로 안 나가게 라벨폭 예약 → 배지가 좌측 안쪽으로 더 모임(라벨 보호)
      const sVal = Math.max(-1, Math.min(1, (bandR - wRightPad - Cx)/RsScreen));
      const as = Math.asin(sVal)*180/PI, a0=180-as, a1=360+as;

      // 배지 6개를 보이는 구간에 분배 : i*60 기준 클램프 + 이웃 밀기(겹침·점프 없음)
      const span=a1-a0, clipC=90;                        // 우측(90°)이 잘리는 쪽 → 배지는 좌측으로 몰림
      const Delta=(360-span)/2, m2=8, lo=Delta+m2, hi=360-Delta-m2, avail=hi-lo;
      const gMin=(2*badgeRs + CFG.gapPx)/RsScreen*180/PI;
      const g=Math.max(gMin, Math.min(52, avail/5.2));
      const rawv=[0,1,2,3,4,5].map(i=>((i*60 - clipC)%360+360)%360);
      const chain=[0,1,2,3,4,5].slice().sort((a,b)=>rawv[a]-rawv[b]);
      const vv=rawv.map(x=>Math.max(lo,Math.min(hi,x)));
      for(let j=1;j<6;j++){ const A=chain[j-1],B=chain[j]; if(vv[B]<vv[A]+g) vv[B]=vv[A]+g; }
      if(vv[chain[5]]>hi){ vv[chain[5]]=hi; for(let j=4;j>=0;j--){ const A=chain[j],B=chain[j+1]; if(vv[A]>vv[B]-g) vv[A]=vv[B]-g; } }
      for(let i=0;i<6;i++) ang[i]=vv[i]+clipC;
      wideCtx={ qmLeft, qmOn, fullFits };
    } else {
      // ── xs : 카피 아래 남는 공간에 풀서클(가로 중앙, 60° 등간격) ──
      const kOuter = ringRcur + badgeWcur/200, kSide = kOuter*Math.sin(60*D2R);
      const availTop = vr.top, availBot = Math.min(hb.bottom, vh);
      const availH = Math.max(140, availBot - availTop - CFG.xs.marginTop - CFG.xs.marginBot);
      // 외곽 링 지름 = 2×0.3806×W (SVG 외곽 스트로크 반지름/viewBox). 폭 기준 목표 W = bgFrac×vw / (2×0.3806)
      const Wwidth = CFG.xs.bgFrac * vw / (2*0.3806);
      const Wv = (availH/2 - CFG.xs.labelV)/kOuter;
      const Wh = (vw/2 - 8 - CFG.xs.labelH)/kSide;
      const W  = Math.max(CFG.xs.minW, Math.min(Wwidth, Wv, Wh, CFG.xs.capK*availH));
      sc = W / w;
      tx = vw/2 - (vr.left + w/2);
      ty = (availTop + availBot)/2 - (vr.top + w/2);
      gsap.set(orbit,{ x:tx, y:ty, scale:sc });
      for(let i=0;i<6;i++) ang[i]=CFG.angles[i];
    }

    // ── 공통 : 배지 각도 배치 → 라벨 방사배치 → 쫀득 스프링 연결선 ──
    if(!tips) tips=nodes.map(()=>({x:211.06,y:211.06,vx:0,vy:0,init:false}));
    // wide에서 배지가 nominal 60° 부근으로 퍼졌으면(풀서클=lgAndUp) 피그마 라벨방향, 아니면(롤링=배지 클러스터) 방사형
    const NOMINAL=[0,60,120,180,240,300];
    const arcFull = (regime!=='narrow') && ang.every((a,i)=>Math.abs(((a-NOMINAL[i])%360+540)%360-180)<18);
    nodes.forEach((n,i)=>{
      const a  = (ang[i] + Math.sin(phase+i*1.1)*CFG.wobble)*D2R;
      const sx = Math.sin(a), cyv = -Math.cos(a);
      n.style.setProperty('--x',(sx*Rpx).toFixed(1)+'px');
      n.style.setProperty('--y',(cyv*Rpx).toFixed(1)+'px');
      if(glows[i]){ glows[i].setAttribute('cx',(211.06+sx*Rglow).toFixed(1)); glows[i].setAttribute('cy',(211.06+cyv*Rglow).toFixed(1)); }   // 발광점=배지 방향의 코어 가장자리(연결선 시작점)에 정렬
      const L=lbls[i], d=badgeR0+(regime==='narrow'?4:12);   // xs: 라벨을 배지 쪽으로 더 붙임(피그마 타이트 간격 + 우측 라벨 화면 밖 방지)
      // 라벨 방향 : xs=피그마 xsOnly 고정방향 / wide 풀서클=피그마 lgAndUp 고정방향 / wide 롤링=방사형(sx,cyv)
      const ld = (regime==='narrow') ? XS_LABEL_DIR[i]
               : arcFull ? WIDE_LABEL_DIR[i]
               : [sx,cyv];
      const lsx=ld[0], lsy=ld[1];
      L.style.setProperty('--ax',lsx.toFixed(3));  L.style.setProperty('--ay',lsy.toFixed(3));
      L.style.setProperty('--lx',(lsx*d).toFixed(1)+'px'); L.style.setProperty('--ly',(lsy*d).toFixed(1)+'px');
      L.style.fontSize = (labelPxCur/sc).toFixed(2)+'px';   // orbit 스케일 상쇄 → 화면상 고정(wide 16 / xs 12px, 피그마 시안)
      const bx=211.06+sx*Rsvg, by=211.06+cyv*Rsvg, t=tips[i], kk=0.20-i*0.013;
      if(instant||!t.init){ t.x=bx; t.y=by; t.vx=0; t.vy=0; t.init=true; }
      else { t.vx=(t.vx+(bx-t.x)*kk)*0.74; t.vy=(t.vy+(by-t.y)*kk)*0.74; t.x+=t.vx; t.y+=t.vy; }
      const ex=t.x.toFixed(1), ey=t.y.toFixed(1);
      linesMain[i].setAttribute('x2',ex); linesMain[i].setAttribute('y2',ey);
      linesGlow[i].setAttribute('x2',ex); linesGlow[i].setAttribute('y2',ey);
      linesPulse[i].setAttribute('x2',ex); linesPulse[i].setAttribute('y2',ey);
    });

    // wide : 라벨 실측으로 정렬 + 좌우 넘침 방지(추정오차 보정. lbl만 측정 → 탭 확대에 안 흔들림)
    if(regime==='wide' && wideCtx){
      let Lx=1e9,Rx=-1e9; for(const L of lbls){ const r=L.getBoundingClientRect(); if(r.left<Lx)Lx=r.left; if(r.right>Rx)Rx=r.right; }
      const bl=copyEl.getBoundingClientRect().right + CFG.wide.gapCopy - 8, br=wideCtx.qmLeft - 10;
      // sm(퀵메뉴 없는 롤링, 특히 카피 4줄로 폭 여유↑) : 라벨을 카피쪽으로 좌측 정렬 → 남는 좌측 여백을 우측(맨살 링 아크)이 덜 잘리게 활용.
      //   lg(풀원)·md(퀵메뉴)는 기존대로 밴드 중앙 정렬(디자인 유지).
      let corr = (!wideCtx.fullFits && !wideCtx.qmOn) ? (bl - Lx) : ((bl+br)/2-(Lx+Rx)/2);
      // 우측 배경카드(글로벌검증-BG)가 라벨보다 더 우측으로 뻗음 → 퀵메뉴 있으면(lg) 카드 우측이 퀵메뉴를 가리지 않게 좌측 이동(피그마 시안처럼 카드가 퀵메뉴 앞에서 끝나게)
      if(wideCtx.qmOn){
        const gcard = orbit.querySelector('.bg-card--global');
        if(gcard){ const gr=gcard.getBoundingClientRect().right, limit=wideCtx.qmLeft - 14; if(gr+corr>limit) corr = limit - gr; }
        corr += CFG.wide.startShiftX;   // 사용자: 아크 전체(bg카드 포함) 기본 +Npx 우측 이동
      }
      if(Rx+corr>br) corr=br-Rx;      // 라벨 우측 화면(또는 퀵메뉴) 밖 방지
      if(Lx+corr<bl) corr=bl-Lx;      // ★ 카피 침범 방지 = 최종 우선
      gsap.set(orbit,{ x: tx+corr });
    }

    // xs : 우측 라벨(AI 분석·글로벌 검증)이 좌측(경험·성과)보다 길어 콘텐츠가 우측으로 쏠림 → 배지 대신 콘텐츠(배지+라벨) bbox 를 화면 가로중앙에
    if(regime==='narrow'){
      let Lx=1e9,Rx=-1e9;
      for(const n of nodes){ const o=n.querySelector('.orb').getBoundingClientRect(); if(o.left<Lx)Lx=o.left; if(o.right>Rx)Rx=o.right; }
      for(const L of lbls){ const r=L.getBoundingClientRect(); if(r.left<Lx)Lx=r.left; if(r.right>Rx)Rx=r.right; }
      gsap.set(orbit,{ x: tx + (vw/2 - (Lx+Rx)/2) });
    }

  }

  /* ── 유휴 애니메이션 : 궤도 phase(미세 흔들림) + 배지 개별 상하 유영 ── */
  let ticker=null, bob=[];
  function startAmbient(){
    ticker = gsap.to({p:0},{p:PI*2,duration:9,ease:'none',repeat:-1,onUpdate:function(){ phase=this.targets()[0].p; render(); }});
    nodes.forEach((n,i)=>bob.push(gsap.to(n.querySelector('.orb'),
      {y:gsap.utils.random(CFG.bobY[0],CFG.bobY[1]),duration:gsap.utils.random(CFG.bobDur[0],CFG.bobDur[1]),ease:'sine.inOut',yoyo:true,repeat:-1,delay:i*0.35})));
  }
  function stopAmbient(){ ticker&&ticker.kill(); bob.forEach(t=>t.kill()); bob=[]; }

  /* ── 로봇손 탭 안무 (주기 반복) : v6 그대로 ── */
  const order = nodes.slice().sort((a,b)=>a.dataset.i-b.dataset.i).map(n=>n.querySelector('.orb'));
  let master=null;
  function buildMaster(){
    const tl=gsap.timeline({repeat:-1,repeatDelay:2.6}), C=1.2;
    tl.set(hand,{opacity:0,xPercent:48,yPercent:44,rotation:-9,scale:1.08,filter:'blur(2px)'},0);
    tl.to(hand,{opacity:1,duration:.3,ease:'power1.out'},0.05);
    tl.to(hand,{xPercent:0,duration:C-0.05,ease:'power2.out'},0.05);
    tl.to(hand,{yPercent:-1,duration:C-0.05,ease:'power3.out'},0.05);
    tl.to(hand,{rotation:2,scale:1,filter:'blur(0px)',duration:C-0.05,ease:'power2.out'},0.05);
    tl.to(hand,{yPercent:-1.7,duration:.12,ease:'power1.out'},C-0.16);
    tl.addLabel('contact',C);
    tl.to(hand,{yPercent:1.4,rotation:3.2,duration:.2,ease:'power2.out'},'contact');
    tl.to(coreVisual,{keyframes:[
      {scale:0.93,duration:.217,ease:'power1.out'},
      {scale:1.07,duration:.186,ease:'power1.out'},
      {scale:1,   duration:.217,ease:'power1.out'}
    ]},'contact');
    tl.set(mint,{opacity:0,scale:.5},0);
    tl.to(mint,{opacity:.42,scale:.85,duration:.55,ease:'sine.out'},C-0.55);
    tl.to(mint,{opacity:1,scale:1.1,duration:.2,ease:'sine.out'},'contact');
    tl.to(mint,{opacity:0,scale:1.55,duration:.85,ease:'sine.in'},'contact+=0.26');
    // 탭 임팩트 제거(사용자 요청): 리플(민트 원형 퍼짐)·연결선 흐름(linesPulse)·라인 플래시(linesMain)·배지 '발광'(drop-shadow) 삭제. 정적 연결선·손·코어눌림·손끝 민트발광은 유지
    tl.set(ripple,{opacity:0},0);
    tl.set(linesPulse,{opacity:0},0);
    tl.set(sheen,{opacity:0},0);   // 증명서 광택(반짝임) 제거(사용자 요청) — 항상 숨김
    tl.to(hand,{yPercent:-4,rotation:0,duration:.6,ease:'power2.out'},'contact+=0.24');
    // 배지 6개 팝(확대) : 원본 v7은 scale+발광이 한 블록 → 발광만 빼고 '확대'는 유지(사용자 요청). .orb 의 bob(y)과 속성이 달라 공존 OK
    tl.to(order,{keyframes:[
      {scale:1.16,duration:.315,ease:'power2.out'},
      {scale:1,   duration:.385,ease:'power2.out'}
    ],stagger:.09},'contact+=0.3');
    tl.to(hand,{xPercent:46,yPercent:40,rotation:-7,scale:1.05,filter:'blur(1.5px)',duration:.9,ease:'power2.in'},'contact+=1.35');
    tl.to(hand,{opacity:0,duration:.55,ease:'power1.in'},'contact+=1.55');
    return tl;
  }

  /* ── 부팅 / 리사이즈 / 정리 ── */
  function boot(){
    setRegime(); render(true);
    if(reduced){ gsap.set(hand,{opacity:1}); return; }
    startAmbient();
    gsap.from(order,{scale:0.3,opacity:0,transformOrigin:'50% 50%',stagger:.07,duration:.5,ease:'back.out(1.5)'});
    master=buildMaster(); master.pause();
    gsap.delayedCall(1.15,()=>master.play());
  }

  let rAF=null, reflowT=null;
  function reflow(){ setRegime(); render(true); }
  function onResize(){
    if(rAF)cancelAnimationFrame(rAF); rAF=requestAnimationFrame(reflow);
    // 회전/브레이크포인트 전환 : Vue v-if(퀵메뉴) 재렌더 + 레이아웃 안정화 후 한 번 더(회전 직후 위치 어긋남 방지)
    clearTimeout(reflowT); reflowT=setTimeout(reflow, 300);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);   // iPad 회전 대응

  boot();
  return { destroy(){ window.removeEventListener('resize',onResize); window.removeEventListener('orientationchange',onResize); if(rAF)cancelAnimationFrame(rAF); clearTimeout(reflowT); master&&master.kill(); stopAmbient(); } };
}
/* eslint-enable */

export default {
    name: 'HomePage',
    components: {
        Swiper,
        SwiperSlide,
        // NewYearModal2025,
        // SeoulMiniSeminaModal,
        // SeoulMiniSeminaModal,
        // Alhe8thForumModal,
        // SeoulRiseForum2025Modal,
        // LoginPathModal,
        UserMainPopup,
    },

    // SECTION: Meta Information
    // metaInfo() {
    //     return getHomeMetaInfo(this);
    // },
    // !SECTION: Meta Information

    // SECTION: Data Properties
    data: function () {
        return {
            isMobile: isMobile,
            isTablet: isTablet,
            isVisualLoading: true,

            seoulRiseForum2025Dialog: false,
            loginPathDialog: true,

            // 팝업 visible 상태 관리용
            systemPopupVisible: false,
            adminPopupVisibleMap: {}, // { [id]: true/false }

            rbnSwiperOptions: {
                loop : true, // 슬라이드 반복 여부
                loopAdditionalSlides : 1,
                autoplay: {
                    delay: 0, // 자동 재생 지연 시간 (0으로 설정하여 계속 스크롤)
                    disableOnInteraction: false // 사용자 상호작용에도 자동 재생 계속
                },
                // slidesPerView: '7', // 화면에 보이는 슬라이드 수 자동 조정
                spaceBetween: 40, // 슬라이드 사이의 간격
                speed: 9000, // 스크롤 속도 (밀리초 단위)
                freemode: false,

                breakpoints: {
                    0: { // 모바일 뷰포트
                        // spaceBetween: 40,
                        slidesPerView: 3
                    },
                    600: { // 태블릿 뷰포트
                        slidesPerView: 5
                    },
                    960: { // 데스크탑 뷰포트
                        slidesPerView: 7
                    },
                    1400: { // 데스크탑 뷰포트
                        slidesPerView: 11
                    }
                }
            },
            rbnImages: [
                require('@/assets/img/home-rbn-1.png'),
                require('@/assets/img/home-rbn-2.png'),
                require('@/assets/img/home-rbn-3.png'),

                require('@/assets/img/home-rbn-4.png'),
                require('@/assets/img/home-rbn-5.png'),
                require('@/assets/img/home-rbn-6.png'),

                require('@/assets/img/home-rbn-7.png'),
                require('@/assets/img/home-rbn-8.png'),
                require('@/assets/img/home-rbn-9.png'),

                require('@/assets/img/home-rbn-10.png'),
                require('@/assets/img/home-rbn-11.png'),
                require('@/assets/img/home-rbn-12.png'),
            ],
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    computed: {
        ...mapGetters('mainPopup', ['getMainPopupList']),

        // ✅ 현재 사이트 언어: 'ko' 또는 'en'
        currentLangCode() {
            const loc = (this.$i18n.locale || '').toLowerCase();
            return loc.startsWith('en') ? 'en' : 'ko';
        },

        // ✅ 언어값에 맞게 필터링된 메인 팝업 목록
        filteredMainPopupList() {
            const lang = this.currentLangCode; // 'ko' or 'en'

            // 백엔드에서 내려주는 popup.language 값은
            // 'both' | 'ko' | 'en' 이라고 가정
            return this.getMainPopupList.filter(popup => {
                const popupLang = (popup.language || 'both').toLowerCase();

                // both → 무조건 노출
                if (popupLang === 'both')
                    return true;

                // ko/en → 현재 언어와 일치할 때만
                return popupLang === lang;
            });
        },

        // 팝업 관련
        adminVisibleCount() {
            return Object.values(this.adminPopupVisibleMap)
                .filter(Boolean).length;
        },
        totalVisiblePopupCount() {
            return (this.systemPopupVisible ? 1 : 0) + this.adminVisibleCount;
        },
        anyPopupVisible() {
            return this.totalVisiblePopupCount > 0;
        },
        useDoubleLayout() {
            return this.$vuetify.breakpoint.lgAndUp &&
            this.totalVisiblePopupCount === 2;
        },
        systemPopupPosition() {
            // 시스템 팝업이 열려 있고, “총 2개”인 경우 → 왼쪽
            if (this.useDoubleLayout && this.systemPopupVisible) {
                return 'left';
            }
            return 'center';
        },
    },

    watch: {
        async currentLangCode(newLang, oldLang) {
            if (newLang === oldLang) return;

            // 1) 시스템 팝업 먼저 켜기 (아래 레이어 역할)
            this.loginPathDialog = true;

            // 2) 그 다음 새 언어 기준으로 Admin 팝업 목록 로드
            await this.fetchMainPopupList(newLang);
            // -> fetch 완료되면서 UserMainPopup 들이 다시 mount
            //    → Admin 팝업들이 “마지막에 열린” 팝업이 되어 항상 맨 위에 옴
        },
    },

    created() {
        //
    },

    mounted() {
        this.isVisualLoading = false;

        const lang = this.currentLangCode;
        this.fetchMainPopupList(lang);

        // 히어로 아크 비주얼 모션 시작
        this.$nextTick(() => {
            this._hero = initHeroMotion(this.$el);
        });
    },

    beforeDestroy() {
        // 히어로 모션 정리 (리스너/타임라인 해제)
        if (this._hero) {
            this._hero.destroy();
            this._hero = null;
        }
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        ...mapActions('mainPopup', ['fetchMainPopupList']),

        onSystemPopupVisibleChange({ visible }) {
            this.systemPopupVisible = visible;
        },
        onAdminPopupVisibleChange({ id, visible }) {
            this.$set(this.adminPopupVisibleMap, id, visible);
        },
        getAdminPopupPosition(idx) {
            // lg 이상 + 총 2개인 상황만 신경 쓴다
            if (!this.useDoubleLayout) return 'center';

            // 케이스 1) 시스템 1개 + Admin 1개  -> Admin = right
            if (this.systemPopupVisible && this.adminVisibleCount === 1) {
                return 'right';
            }

            // 케이스 2) 시스템 0개 + Admin 2개   -> idx 0 = left, idx 1 = right
            if (!this.systemPopupVisible && this.adminVisibleCount === 2) {
                return idx === 0 ? 'left' : 'right';
            }

            // 그 외에는 그냥 가운데
            return 'center';
        },
    },
    // !SECTION: Methods
};
</script>
